import { Product } from '@inter-ikea-storageone/range';

const INTERIORS_PRIORITY_ORDER = ['ART-20278167', 'ART-70286645', 'ART-90495695', 'ART-20423720'];

const getSortingOrderOfProduct = (product: Product) => {
  const index = INTERIORS_PRIORITY_ORDER.indexOf(product.globalItemNo);
  const order = index >= 0 ? index : INTERIORS_PRIORITY_ORDER.length;

  return order;
};

export const sortInteriors = (clusters: Product[][]) =>
  [...clusters].sort(
    (clusterA, clusterB) =>
      getSortingOrderOfProduct(clusterA[0]) - getSortingOrderOfProduct(clusterB[0])
  );
